var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackRightArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 106,
    viewBox: "0 0 34 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47617 17.3288C1.50178 30.8506 6.39347 36.3424 6.39347 36.3424C6.39347 39.2274 9.81063 44.4245 11.1219 46.8283C9.81064 51.0244 11.0127 57.1003 11.7776 59.6138L18.334 79.9381C17.5472 83.872 17.6783 88.4614 17.6783 88.4614C17.6783 88.4614 18.1154 94.3622 18.334 95.6734C18.334 100.263 18.9896 103.869 19.3174 103.541C19.5797 103.279 19.7826 96.6525 19.9731 95.6734C20.1635 94.6943 20.4913 95.0221 20.6287 95.6734C20.7661 96.3247 21.2843 105.508 21.94 105.18C22.4645 104.918 22.0774 96.6525 22.2678 95.6734C22.4582 94.6943 22.7861 95.0221 22.9234 95.6734C23.0608 96.3247 24.5625 106.164 25.2182 105.508C25.7427 104.984 25.2182 98.5146 24.8903 95.3456C24.8903 94.5589 25.3274 95.0178 25.5459 95.3456C26.5294 100.263 28.4963 104.852 29.152 104.197C29.6765 103.672 27.0478 90.7606 28.1685 92.3953C29.2892 94.0299 32.5674 95.9968 33.0858 95.3456C33.6042 94.6944 31.0096 90.8654 30.4633 89.1171C29.8076 88.1336 30.1354 85.1832 28.4963 83.8719C27.1851 82.8229 25.546 79.9381 24.8903 78.6268L23.579 59.6138C23.8412 53.8441 21.9399 48.2493 20.9564 46.1731C22.2677 39.3544 19.18 29.1303 17.6783 23.8812C17.6783 20.9349 17.7063 20.9417 17.6783 19.9514C17.5393 15.0341 17.1319 12.0797 16.367 10.1127C13.7444 2.76956 6.97481 0.728926 3.91782 0.626497C3.38138 1.43744 1.45814 7.80775 1.47617 17.3288Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.584 47.8105C14.6443 47.995 17.1781 48.125 18.8309 47.1693",
    stroke: "#202E5F",
    strokeWidth: 0.65564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRightArm);
export default __webpack_public_path__ + "static/media/BackRightArm.252a9bed6e8ab7d0d6e31eb9446ff293.svg";
export { ForwardRef as ReactComponent };